export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/lunescivismo.jpg',
	   "funcion": 'Lunes Cívico',
		"url" : 'https://www.facebook.com/share/v/1Avheo9zRB/',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/dulce.jpg',
	   "funcion": 'Contraloría en acción.',
		"url" : 'https://www.facebook.com/share/v/1C9Qfo6wxj/',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	   "funcion": 'Video Semanal',
		"url" : 'https://www.facebook.com/share/v/1BkTeB3B4h/',
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]